import { forwardRef, type HTMLAttributes, type ForwardedRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/cn';

const toneCardVariants = cva('rounded-lg border', {
  variants: {
    tone: {
      default: 'border-border bg-accent text-accent-foreground',
      success: 'border-success-line bg-success-tint text-success-text',
      warning: 'border-warning-line bg-warning-tint text-warning-text',
      info: 'border-info-line bg-info-tint text-info-text',
      destructive: 'border-destructive-line bg-destructive-tint text-destructive-text',
    },
  },
  defaultVariants: { tone: 'default' },
});

export interface ToneCardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof toneCardVariants> {}

export const ToneCard = forwardRef(function ToneCard(
  { className, tone, ...props }: ToneCardProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return <div ref={ref} className={cn(toneCardVariants({ tone }), className)} {...props} />;
});

export type ToneCardTone = NonNullable<VariantProps<typeof toneCardVariants>['tone']>;
